import script from "./OrcamentoProjetoGastoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrcamentoProjetoGastoFormView.vue?vue&type=script&setup=true&lang=js"

import "./OrcamentoProjetoGastoFormView.vue?vue&type=style&index=0&id=0abb9e61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abb9e61"]])

export default __exports__